module.exports = __webpack_public_path__ + "static/product-family-home-original-113768ff1273ae45d85457a0e986da35.png";